export default __webpack_public_path__ + "static/media/new-window.43bf2ca4.svg";